import theme from "../../themes/themes";
import { createStyles, makeStyles } from "@material-ui/core";

const styles = makeStyles(() =>
	createStyles({
		drawerHeader: {
			display: "flex",
			alignItems: "center",
			padding: theme.spacing(0, 1),
			// necessary for content to be below app bar
			...theme.mixins.toolbar,
		},
		content: {
			flexGrow: 1,
			padding: theme.spacing(3),
			transition: theme.transitions.create("margin", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			marginLeft: 0,
		},
		navigationLink: {
			textDecoration: "none",
			color: `${theme.palette.text.primary}`,
		},
		imgLogo: {
			height: "60px",
			marginRight: "25px",
		},
		navigationDrawer: {
			width: "100%",
		},
		drawerWidth: {
			width: "250px",
		},
		listItemIcon: {
			minWidth: "40px",
		},
		nested: {
			paddingLeft: theme.spacing(4),
		},
		loginInfoContainer: {
			position: "absolute",
			top: "80px",
			left: "0",
			width: "100%",
			height: "90%",
			backgroundColor: "#fff",
		},
		loginInfo: {
			position: "absolute",
			left: "20px",
			top: "10px",
		},
	})
);
export default styles;
